import { FaqType } from './types'
import { SAVE_FAQ } from './actionTypes'
import { ModelCategory } from '../../../types/faq/faq_model'

const initialState: ModelCategory[] = []

const faq = (
	state: ModelCategory[] = initialState,
	action: FaqType
): ModelCategory[] => {
	switch (action.type) {
		case SAVE_FAQ: {
			return action.payload || initialState
		}
		default:
			return state
	}
}

export default faq
